// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"ofW0Y","loadingIcon":"_2LUJ5","info":"_1cp1w"};